<template>
    <div>
        <div class="col-sm-10">
            <!-- <p class="text-center">Check Captcha</p> -->
            <vue-recaptcha
                ref="recaptcha"
                :sitekey="site_key"
                @verify="onVerify"
            >
            </vue-recaptcha>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
    components: {
        VueRecaptcha,
    },
    props: {
        forceRerenderRecaptcha: {
            type: Number
        }
    },
    watch: {
        forceRerenderRecaptcha(val){
            console.log("changing val")
            this.$refs.recaptcha.reset()
            // this.recaptchaResponse = null
        },
    },
    data() {
        return {
            robot: false,
            site_key: process.env.VUE_APP_RECAPTCHA_TOKEN,
        }
    },
    methods: {
        submit: function () {
            if (this.robot) {
                console.log('Robot-submit')
            }
        },
        onVerify: function (response) {
            if (response) {
                this.robot = true
                console.log('Robot-onVerify' + JSON.stringify(response))
                this.$emit('onVerify', response)
            }
        },
    },
}
</script>
